import CubeGeoBuffer from './CubeGeoBuffer.vue';

export default CubeGeoBuffer;
